<template>
  <SalesRegisterTableCard :is-empty="! tableItems.length" :is-loaded="isLoaded">
    <table class="table register-table">
      <thead>
      <tr>
        <th class="text-center">SL No.</th>
        <th>Item</th>
        <th class="num">Sales Qty</th>
        <th class="num">Bonus Qty</th>
        <th class="num">Total Qty</th>
        <th class="num">Invoice Amount</th>
        <th class="num">Vat Amount</th>
        <th class="num">Total Amount</th>
        <th class="num">COGS</th>
        <th class="num">Gross Profit</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, i) in tableItems" :key="i">
        <td class="text-center">{{ (currentPage - 1) * perPage + (i + 1) }}</td>
        <td>{{ item.product_name }}</td>
        <td class="num">{{ item.net_quantity }}</td>
        <td class="num">{{ item.bonus_quantity }}</td>
        <td class="num">{{ item.total_bonus_quantity }}</td>
        <td class="num">{{ commaFormat(item.net_invoice_amount) }}</td>
        <td class="num">{{ item.total_vat_amount ? commaFormat(item.total_vat_amount) : '' }}</td>
        <td class="num">{{ commaFormat(item.gross_invoice_amount) }}</td>
        <td class="num">{{ item.stocks_sum_stock_value ? commaFormat(item.stocks_sum_stock_value) : '' }}</td>
        <td class="num">{{ item.stocks_sum_profit_value ? commaFormat(item.stocks_sum_profit_value) : '' }}</td>
      </tr>
      </tbody>
      <tfoot v-if="isLastPage">
      <tr>
        <td colspan="2" class="register-total-label">Total</td>
        <td class="num">{{ totalValue && totalValue.total_net_quantity }}</td>
        <td class="num">{{ totalValue && totalValue.total_bonus_quantity }}</td>
        <td class="num">{{ totalValue && totalValue.total_total_bonus_quantity }}</td>
        <td class="num">{{ totalValue && totalValue.total_net_invoice_amount }}</td>
        <td class="num">{{ totalValue && totalValue.total_vat_amount }}</td>
        <td class="num">{{ totalValue && totalValue.total_gross_invoice_amount }}</td>
        <td class="num">{{ totalValue && totalValue.stocks_sum_stock_value }}</td>
        <td class="num">{{ totalValue && totalValue.stocks_sum_profit_value }}</td>
      </tr>
      </tfoot>
    </table>
  </SalesRegisterTableCard>
</template>

<script setup>
import { computed } from 'vue'
import figureFormatter from '@/services/utils/figureFormatter'
import SalesRegisterTableCard from '@/components/molecule/company/inventory/product-sales-register/SalesRegisterTableCard.vue'

const { commaFormat } = figureFormatter()

const props = defineProps({
  tableItems: {
    type: Array
  },
  currentPage: Number,
  lastPage: Number,
  perPage: Number,
  totalValue: Object,
  isLoaded: {
    type: Boolean,
    default: true
  }
})

const isLastPage = computed(() => {
  if (! props.tableItems.length) return false
  return props.currentPage === props.lastPage
})
</script>
